import React from 'react';
import { Button } from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.error.main,
  },
}));

interface Props {
  onClick: any;
  loading: boolean;
  disabled: boolean;
  label: string;
  unarchive: boolean;
}

const ArchiveButton = (props: any) => {
  const { onClick, loading, disabled, label, unarchive, ...rest } = props;
  const classes = useStyles();

  return (
    <Button
      label={label}
      onClick={onClick}
      className={classes.root}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <CircularProgress size={18} thickness={2} classes={{ svg: classes.root }} />
      ) : unarchive ? (
        <UnarchiveIcon />
      ) : (
        <ArchiveIcon />
      )}
    </Button>
  );
};

export default ArchiveButton;
